import  Model from '../Apis/Log'
import Controller from './Controller'

export default class LogController extends Controller {
  constructor() {
    super(new Model())
  }
}
